import React, { useState, useEffect, useRef } from "react";
import emailjs from "emailjs-com";
import { Helmet } from "react-helmet";
import "../Css/fortishealthcare.css";
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PersonIcon from "@mui/icons-material/Person";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import fortilogo from "../Images/home/logo.png";
import { countriesList } from "../utility/constants";
import GroupIcon from "@mui/icons-material/Group";
import PublicIcon from "@mui/icons-material/Public";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import rx__logo from "../Images/home/RxOne_Color.png";
import herophoto from "../Images/home/surgeries.jpg";
import forties from "../Images/home/Fortis_Gurugram_.jpg";
import drManjinderSandhu from "../Images/home/dr-(col)-manjinder-sandhu.png";
import drAshokSeth from "../Images/home/dr-ashok-seth.jpg";
import drSandeepVaishya from "../Images/home/dr-sandeep-vaishya.jpg";
import isaps from "../Images/home/isaps.png";
import jcl from "../Images/home/jcl.png";
import esmo from "../Images/home/esmo.png";
import oeci from "../Images/home/oeci_logo.jpeg";
import iso from "../Images/home/iso.png";
import efqm from "../Images/home/efqm_logo.jpeg";
import ada from "../Images/home/ada.png";
import dkg from "../Images/home/dkg.png";
import FortisContactModal from "../components/FortisContactModal";
import FaWh from "@mui/icons-material/WhatsApp";
import { InputLabel, MenuItem, Select, FormControl } from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TelegramIcon from "@mui/icons-material/Telegram";
import { Phone, Calendar, MessageCircle, Star, Award, Heart, Brain, Stethoscope } from "lucide-react";
import { FaWhatsapp, FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaTelegram, FaGooglePlay, FaApple, FaMedal, FaAward, FaCertificate } from "react-icons/fa";
import { IoLanguageOutline } from "react-icons/io5";
import { LiaTelegram } from "react-icons/lia";
import { Link, useNavigate } from "react-router-dom";
import { AlertCircle, Send, Loader2 } from "lucide-react";
import { FaCalendarCheck, FaUserMd, FaPlane, FaPassport } from "react-icons/fa";


const FortisHealthcare = () => {
  const navigate = useNavigate();
  const [country, setCountry] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [departmentDropdownOpen, setDepartmentDropdownOpen] = useState(false);
  const [doctorDropdownOpen, setDoctorDropdownOpen] = useState(false);
  const [fortisContactModalOpen, setFortisContactModalOpen] = useState(false);

  const actions = [
    {
      icon: <PhoneIcon style={{ height: 24, width: 24, color: "#4B5563" }} />,
      label: "Emergency",
  },
    {
      icon: (
        <CalendarTodayIcon
          style={{ height: 24, width: 24, color: "#4B5563" }}
        />
      ),
      label: "Book Appointment",
    },
    {
      icon: <PersonIcon style={{ height: 24, width: 24, color: "#4B5563" }} />,
      label: "Find Doctor",
    },
    {
      icon: (
        <LocationOnIcon style={{ height: 24, width: 24, color: "#4B5563" }} />
      ),
      label: "Directions",
    },
  ];
  const stats = [
    { value: "4850+", label: "Happy Patients" },
    { value: "58+", label: "Specialist Doctors" },
    { value: "345+", label: "Success Operations" },
    { value: "25+", label: "Years of Experience" },
  ];
  const highlights = [
    "JCI & NABH Accredited Hospital",
    "24/7 Emergency Services",
    "Multi-specialty Tertiary Care",
    "Robotic Surgery Center",
    "International Patient Services",
    "Organ Transplant Programs",
    "Comprehensive Cancer Care",
  ];
  const accreditations = [
    { name: "ISO", imgSrc: iso },
    { name: "JCI", imgSrc: jcl },
    { name: "ESMO", imgSrc: esmo },
    { name: "OECI", imgSrc: oeci },
    { name: "EFQM", imgSrc: efqm },
    { name: "ADA", imgSrc: ada },
    { name: "ISAPS", imgSrc: isaps },
    { name: "DKG", imgSrc: dkg },
  ];
  const doctors = [
    {
      id: "1",
      name: "Dr. Sandeep K",
      specialty: "Cardiologist",
      experience: "15+ years experience",
      image:
        "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80",
      rating: 4.9,
    },
    {
      id: "2",
      name: "Dr. Rakesh Sharma",
      specialty: "Neurologist",
      experience: "12+ years experience",
      image:
        "https://images.unsplash.com/photo-1622253692010-333f2da6031d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80",
      rating: 4.8,
    },
    {
      id: "3",
      name: "Dr. Priya Singh",
      specialty: "Oncologist",
      experience: "10+ years experience",
      image:
        "https://images.unsplash.com/photo-1594824476967-48c8b964273f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80",
      rating: 4.7,
    },
  ];
  const offices = [
    {
      country: "US",
      flag: "https://flagcdn.com/w40/us.png",
      address: ["16192 Coastal Highway,", "Lewes, United States of", "America"],
    },
    {
      country: "SG",
      flag: "https://flagcdn.com/w40/sg.png",
      address: [
        "Vision Exchange, #",
        "13-30, No-02 Venture",
        "Drive,",
        "Singapore-608526",
      ],
    },
    {
      country: "DE",
      flag: "https://flagcdn.com/w40/de.png",
      address: [
        "Wework Building",
        "Warschauer Platz 11-13",
        "Berlin, BE 10245",
      ],
    },
    {
      country: "UK",
      flag: "https://flagcdn.com/w40/gb.png",
      address: [
        "London - Wework",
        "Building",
        "22 Long Acre",
        "London WC2E 9LY",
      ],
    },
    {
      country: "IN",
      flag: "https://flagcdn.com/w40/in.png",
      address: ["211, 2nd Floor, DLF Tower", "A, Jasola, Delhi 110025"],
    },
    {
      country: "BD",
      flag: "https://flagcdn.com/w40/bd.png",
      address: [
        "Level-6, House 77,",
        "Road-12, Block-E,",
        "Banani, Dhaka-1213",
      ],
    },
  ];
  const reasons = [
    {
      icon: "🏥",
      title: "Advanced Medical Infrastructure",
      description:
        "State-of-the-art facilities with cutting-edge medical technology for accurate diagnosis and treatment.",
    },
    {
      icon: "👨‍⚕️",
      title: "Expert Medical Professionals",
      description:
        "Team of highly qualified doctors with extensive experience in their respective specialties.",
    },
    {
      icon: "🌐",
      title: "Global Healthcare Standards",
      description:
        "Maintaining international healthcare standards with JCI accreditation and quality patient care.",
    },
    {
      icon: "💰",
      title: "Affordable Treatment Options",
      description:
        "Quality healthcare at competitive prices with transparent billing and multiple payment options.",
    },
  ];
  const specialities = [
    { name: "Cardiology", icon: "❤️", lucideIcon: <Heart className="w-5 h-5" /> },
    { name: "Neurology", icon: "🧠", lucideIcon: <Brain className="w-5 h-5" /> },
    { name: "Orthopedics", icon: "🦴", lucideIcon: <Stethoscope className="w-5 h-5" /> },
    { name: "Oncology", icon: "⚕️", lucideIcon: <Award className="w-5 h-5" /> },
    { name: "ENT", icon: "👂", lucideIcon: <Phone className="w-5 h-5" /> },
    { name: "Gastroenterology", icon: "🫁", lucideIcon: <Stethoscope className="w-5 h-5" /> },
    { name: "Gynaecology", icon: "👩", lucideIcon: <Award className="w-5 h-5" /> },
    { name: "Pediatrics", icon: "👶", lucideIcon: <Heart className="w-5 h-5" /> },
    { name: "Dermatology", icon: "🧴", lucideIcon: <Stethoscope className="w-5 h-5" /> },
    { name: "Ophthalmology", icon: "👁️", lucideIcon: <Award className="w-5 h-5" /> },
    { name: "Dentistry", icon: "🦷", lucideIcon: <Stethoscope className="w-5 h-5" /> },
    { name: "Pulmonology", icon: "🫁", lucideIcon: <Brain className="w-5 h-5" /> },
    { name: "Urology", icon: "🧬", lucideIcon: <Award className="w-5 h-5" /> },
    { name: "Psychiatry", icon: "🧠", lucideIcon: <Brain className="w-5 h-5" /> },
    { name: "Physiotherapy", icon: "💪", lucideIcon: <Heart className="w-5 h-5" /> },
    { name: "Diabetes", icon: "💉", lucideIcon: <Stethoscope className="w-5 h-5" /> },
    { name: "Radiology", icon: "📱", lucideIcon: <Award className="w-5 h-5" /> },
    { name: "Nephrology", icon: "🧪", lucideIcon: <Stethoscope className="w-5 h-5" /> },
  ];
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSpeciality, setSelectedSpeciality] = useState("");

  const handleSpecialityClick = (name) => {
    setSelectedSpeciality(name);
    setModalOpen(true);
  };
  const countersRef = useRef([]);

  useEffect(() => {
    let hasAnimated = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            hasAnimated = true; // Prevent rerun

            countersRef.current.forEach((el, i) => {
              if (!el) return;
              let start = 0;
              const end = Number(stats[i].value.replace("+", ""));
              const duration = 2000;
              const increment = Math.ceil(end / (duration / 16));

              const counter = setInterval(() => {
                start += increment;
                if (start >= end) {
                  el.textContent = `${end.toLocaleString()}+`;
                  clearInterval(counter);
                } else {
                  el.textContent = start.toLocaleString();
                }
              }, 16);
            });

            observer.disconnect(); // Only trigger once
          }
        });
      },
      { threshold: 0.4 }
    );

    const target = document.querySelector(".hospital5stats5banner");
    if (target) observer.observe(target);

    return () => observer.disconnect();
  }, []);

  const testimonials = [
    {
      name: "John Smith",
      country: "USA",
      comment:
        "The care I received at Fortis was exceptional. The doctors were attentive and the staff was incredibly supportive throughout my treatment.",
      avatar: "https://i.pravatar.cc/100?img=1",
    },
    {
      name: "Emma Johnson",
      country: "UK",
      comment:
        "I traveled from London for my cardiac treatment and couldn't be happier with my decision. World-class facilities and outstanding medical expertise.",
      avatar: "https://i.pravatar.cc/100?img=2",
    },
    {
      name: "Mohammed Al-Fayed",
      country: "UAE",
      comment:
        "The international patient services at Fortis made my medical journey smooth and hassle-free. Excellent treatment with personal care.",
      avatar: "https://i.pravatar.cc/100?img=3",
    },
  ];
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [message, setMessage] = useState("");
  const [messageError, setMessageError] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);

  const resetForm = () => {
    setName("");
    setNameError("");
    setEmail("");
    setEmailError("");
    setPhone("");
    setPhoneError("");
    setCountry("");
    setMessage("");
    setMessageError("");
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    // Allow numbers, spaces, and mathematical symbols (+, -, *, /)
    const validCharacters = value.replace(/[^0-9+\-*/\s]/g, "");
    setPhone(validCharacters);

    // Validate the phone number
    if (validCharacters.trim() === "") {
      setPhoneError("Phone number is required");
    } else {
      setPhoneError("");
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    setNameError(
      value.trim() === ""
        ? "Name is required"
        : value.length < 2
          ? "Name must be at least 2 characters"
          : ""
    );
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(
      value && !emailRegex.test(value)
        ? "Please enter a valid email address"
        : ""
    );
  };

  const handleMessageChange = (e) => {
    const value = e.target.value;
    setMessage(value);
    setMessageError(
      value.trim() === ""
        ? "Message is required"
        : value.length < 10
          ? "Message should be at least 10 characters"
          : ""
    );
  };

  const validateForm = () => {
    let isValid = true;

    if (name.trim() === "") {
      setNameError("Name is required");
      isValid = false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email.trim() === "") {
      setEmailError("Email is required");
      isValid = false;
    } else if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
      isValid = false;
    }
    if (phone.trim() === "") {
      setPhoneError("Phone number is required");
      isValid = false;
    }
    if (!country) {
      isValid = false;
    }
    if (message.trim() === "") {
      setMessageError("Message is required");
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    const messageContent = `
      Name: ${name}
      Email: ${email}
      Phone: ${phone}
      Country: ${country}
      Query: ${message}
    `;

    emailjs
      .send(
        "service_7yxtqsn",
        "template_x3wusd7",
        {
          from_name: name,
          from_email: email,
          to_name: "web",
          message: messageContent,
        },
        "4UpyJJj3P5JGeMZFz"
      )
      .then(() => {
        setLoading(false);
        setAlertOpen(true);
        resetForm();
        navigate('/hospitals/fortis/thank-you');
      })
      .catch((error) => {
        setLoading(false);
        console.error("Email sending error:", error);
      });
  };
  useEffect(() => {
    const addTranslateScript = () => {
      if (!document.getElementById("google-translate-script")) {
        const script = document.createElement("script");
        script.id = "google-translate-script";
        script.src =
          "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        script.async = true;
        document.body.appendChild(script);
      }
    };

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "en,fr,ar,ru,bn,hi,ro,es,pt",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false,
        },
        "google_translate_element"
      );
    };

    addTranslateScript();
  }, []);
  const countersRef2 = useRef([]);
  useEffect(() => {
    let hasAnimated = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            hasAnimated = true;

            countersRef2.current.forEach((el, i) => {
              if (!el) return;
              let start = 0;
              const end = Number(stats[i].value.replace(/\D/g, "")); // remove non-digits
              const duration = 2000;
              const increment = Math.ceil(end / (duration / 16));

              const counter = setInterval(() => {
                start += increment;
                if (start >= end) {
                  el.textContent = `${end.toLocaleString()}+`;
                  clearInterval(counter);
                } else {
                  el.textContent = start.toLocaleString();
                }
              }, 16);
            });

            observer.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );

    const target = document.querySelector(".stats5grid2");
    if (target) observer.observe(target);

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Best hospital in India for healthcare services - Fortis Hospital
        </title>
        <meta
          name="description"
          content="Explore top-quality healthcare services at Fortis Hospital, one of the best hospitals in India."
        />
      </Helmet>
      <div className="fortis-container">
        {/* Header Component */}
        <header className="bg-white shadow-sm sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center py-3">
            <div>
              <Link to="/hospitals/fortis" className="flex items-center">
                <img src={fortilogo} alt="Fortis Logo" className="h-9 sm:h-10 md:h-12" />
              </Link>
            </div>

            <div className="flex items-center space-x-2 sm:space-x-3 md:space-x-4">
              <div className="flex items-center mr-1 sm:mr-2 mt-1">
                <span className="flex items-center text-gray-600 text-sm mr-2">
                  <IoLanguageOutline className="w-4 h-4 mr-1" />
                  <span className="hidden md:inline">Select Language:</span>
                </span>
                <div id="google_translate_element"></div>
              </div>

              <a
  href="tel:+911140847007"
                className="hidden sm:flex items-center text-gray-700 hover:text-green-600 text-sm py-2 px-3 border border-gray-200 rounded-md transition-colors"
              >
                <Phone size={16} className="mr-2" />
                <span>+91 011-408-47007</span>
              </a>

             <button
  className="bg-green-600 hover:bg-green-700 text-white text-sm py-2 px-2 sm:px-4 rounded-md transition-colors flex items-center hide-on-mobile"
  onClick={() => setFortisContactModalOpen(true)}
>
  <span>Callback Request</span>
</button>
<a
  href="tel:+911140847007"
  className="bg-green-600 hover:bg-green-700 text-white text-sm py-2 px-2 sm:px-4 rounded-md transition-colors flex items-center show-on-mobile"
  style={{ marginLeft: "10px", marginTop: "8px", fontWeight: 600, justifyContent: "center" }}
>
  +91 011-408-47007
</a>
            </div>
          </div>
        </header>

        {/* Hero Section Component */}
        <section
          className="hero5section"
          style={{
            backgroundImage: `url(${herophoto})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="hero5container">
            <div className="hero5content">
              <h1 className="hero5title ">
                Unbeatable Reasons
                <br />
                to Choose Us:
                <br />
                Your One-Stop Solution!
              </h1>

              <div className="hero5description">
                <ul className="hero5points">
                  <li>Hassle-Free Medical Visa</li>
                  <li>Flight Tickets</li>
                  <li>Travel Stay for Treatment</li>
                  <li>Best Personalized Care</li>
                  <li>No Waiting List</li>
                  <li>24/7 Patient Care</li>
                  <li>Low Economical Cost</li>
                </ul>
              </div>
              <div className="hero5buttons">
                {/* <button
                  className="learn5more5button"
                  onClick={() => setFortisContactModalOpen(true)} // Open the modal on button click
                >
                  Learn More
                </button> */}

                {/* Add the FortisContactModal */}
                <FortisContactModal
                  open={fortisContactModalOpen}
                  onClose={() => setFortisContactModalOpen(false)} // Close the modal when triggered
                />
                <button
                  className="learn5more5button"
                  onClick={() => setFortisContactModalOpen(true)}
                >
                  Contact Us

                </button>
                <a
                  href="https://api.whatsapp.com/send?phone=+917703934446&text=Hello%20Team,%20Please%20call%20back.%20Looking%20for%20treatment%20in%20India."
                  className="social-icon-button whatsapp-button text-2xl hover:text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp />
                </a>
                <a
                  href="https://t.me/RxOneSupport"
                  className="social-icon-button telegram-button text-2xl  hover:text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LiaTelegram />
                </a>
              </div>
            </div>

            <div className="form5container">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden animate-[fadeIn_0.3s_ease-out] w-full max-w-md mx-auto">
                <div className="bg-green-600 text-white py-2 sm:py-3 px-4 sm:px-6 relative flex items-center justify-center">
                  <h2 className="text-lg sm:text-xl font-semibold m-0 text-center">Request a Consultation</h2>
                </div>

                <div className="p-4 sm:p-6 bg-neutral-50">
                  <p className="text-center text-neutral-500 text-xs sm:text-sm mt-0 mb-3 sm:mb-4">
                    Fill out the form and our team will get back to you shortly.
                  </p>

                  <form onSubmit={handleSubmit} className="flex flex-col gap-2 sm:gap-3">
                    <div className="flex flex-col">
                      <label htmlFor="name" className="mb-1 text-xs sm:text-sm font-medium text-neutral-600">Name*</label>
                      <input
                        id="name"
                        type="text"
                        className={`px-2 sm:px-3 py-1.5 sm:py-2 border ${nameError ? 'border-red-500 bg-red-50' : 'border-neutral-200'} rounded-md text-xs sm:text-sm bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 focus:border-green-500 transition w-full h-10`}
                        value={name}
                        onChange={handleNameChange}
                        placeholder="Your full name"
                        required
                      />
                      {nameError && (
                        <div className="flex items-center gap-1 text-red-600 text-xs mt-1">
                          <AlertCircle size={10} className="sm:w-3 sm:h-3" />
                          <span>{nameError}</span>
                        </div>
                      )}
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="email" className="mb-1 text-xs sm:text-sm font-medium text-neutral-600">Email*</label>
                      <input
                        id="email"
                        type="email"
                        className={`px-2 sm:px-3 py-1.5 sm:py-2 border ${emailError ? 'border-red-500 bg-red-50' : 'border-neutral-200'} rounded-md text-xs sm:text-sm bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 focus:border-green-500 transition w-full h-10`}
                        value={email}
                        onChange={handleEmailChange}
                        placeholder="Your email address"
                        required
                      />
                      {emailError && (
                        <div className="flex items-center gap-1 text-red-600 text-xs mt-1">
                          <AlertCircle size={10} className="sm:w-3 sm:h-3" />
                          <span>{emailError}</span>
                        </div>
                      )}
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="phone" className="mb-1 text-xs sm:text-sm font-medium text-neutral-600">Phone*</label>
                      <input
                        id="phone"
                        type="tel"
                        className={`px-2 sm:px-3 py-1.5 sm:py-2 border ${phoneError ? 'border-red-500 bg-red-50' : 'border-neutral-200'} rounded-md text-xs sm:text-sm bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 focus:border-green-500 transition w-full h-10`}
                        value={phone}
                        onChange={handlePhoneChange}
                        placeholder="+91 xxxxx xxxxx"
                        required
                      />
                      {phoneError && (
                        <div className="flex items-center gap-1 text-red-600 text-xs mt-1">
                          <AlertCircle size={10} className="sm:w-3 sm:h-3" />
                          <span>{phoneError}</span>
                        </div>
                      )}
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="country" className="mb-1 text-xs sm:text-sm font-medium text-neutral-600">Country*</label>
                      <select
                        id="country"
                        className={`px-2 sm:px-3 py-1.5 sm:py-2 border ${!country && 'border-red-500 bg-red-50'} border-neutral-200 rounded-md text-xs sm:text-sm bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 focus:border-green-500 transition w-full h-10`}
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                        required
                      >
                        <option value="">Select your country</option>
                        {countriesList.map((item, index) => (
                          <option value={item.name} key={`${item.name}-${index}`}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="message" className="mb-1 text-xs sm:text-sm font-medium text-neutral-600">Your Query*</label>
                      <textarea
                        id="message"
                        className={`px-2 sm:px-3 py-1.5 sm:py-2 border ${messageError ? 'border-red-500 bg-red-50' : 'border-neutral-200'} rounded-md text-xs sm:text-sm bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 focus:border-green-500 transition resize-y min-h-[80px] sm:min-h-[90px] w-full`}
                        value={message}
                        onChange={handleMessageChange}
                        rows={3}
                        placeholder="How can we help you?"
                        required
                      ></textarea>
                      {messageError && (
                        <div className="flex items-center gap-1 text-red-600 text-xs mt-1">
                          <AlertCircle size={10} className="sm:w-3 sm:h-3" />
                          <span>{messageError}</span>
                        </div>
                      )}
                    </div>

                    <button
                      type="submit"
                      className="flex items-center justify-center gap-1 sm:gap-2 mt-2 bg-green-600 text-white py-1.5 sm:py-2 px-4 sm:px-5 border-none rounded-md text-sm sm:text-base font-semibold cursor-pointer transition duration-200 ease-in-out hover:bg-green-700 hover:-translate-y-1 active:translate-y-0 disabled:cursor-not-allowed self-center disabled:hover:translate-y-0 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                      disabled={loading}
                    >
                      {loading ? (
                        <Loader2 className="w-4 h-4 sm:w-5 sm:h-5 animate-spin" />
                      ) : (
                        <>
                          <Send size={14} className="sm:w-4 sm:h-4" />
                          <span>Submit Request</span>
                        </>
                      )}
                    </button>
                  </form>
                </div>

                {alertOpen && (
                  <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-green-600 text-white py-1.5 sm:py-2 px-3 sm:px-5 rounded shadow-lg z-10 font-medium text-xs sm:text-sm animate-[messageAppear_0.3s_ease-out]">
                    Message sent successfully!
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        <section className="action5section">
          <div className="action5container">
            <div className="action5grid">
              {actions.map((action, index) => (
                <div
                  key={index}
                  className="action5item"
                  onClick={() => setFortisContactModalOpen(true)}
                >
                  <div className="action5icon">{action.icon}</div>
                  <p className="action5label">{action.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Add the FortisContactModal */}
          <FortisContactModal
            open={fortisContactModalOpen}
            onClose={() => setFortisContactModalOpen(false)}
          />
        </section>
        <section className="top5doctors5section">
          <div className="container2">
            <div className="top5header">
              <h2 className="text-3xl font-bold text-center mb-8 text-neutral-800">
                Top Doctors - <span className="text-green-600">Fortis Memorial Hospital, India</span>
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Doctor 1 */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-2 border border-neutral-100">
                <div className="relative flex justify-center border-b">
                  <img
                    src={drManjinderSandhu}
                    alt="Dr. (Col) Manjinder Sandhu"
                    className="h-60 object-contain rounded-lg"
                  />
                </div>

                <div className="p-6">
                  <div className="flex items-center mb-2">
                    <div className="h-3 w-3 rounded-full bg-green-500 mr-2"></div>
                    <span className="text-sm font-medium text-green-600">Available for Consultation</span>
                  </div>

                  <h3 className="text-xl font-bold text-neutral-900 mb-1">Dr. (Col) Manjinder Sandhu</h3>

                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center">
                      <Heart size={16} className="text-blue-600 mr-1.5" />
                      <span className="text-blue-700 text-sm font-medium">Cardiologist</span>
                    </div>
                    <div className="flex items-center text-amber-400">
                      <Star size={16} className="mr-1 fill-amber-400" />
                      <span className="text-sm font-medium">4.9</span>
                    </div>
                  </div>

                  <div className="mb-4 text-neutral-500 text-sm">
                    <p>25+ years experience</p>
                    <p className="mt-1">Specializes in complex cardiovascular interventions and cardiac care</p>
                  </div>

                  <div className="pt-4 border-t border-neutral-100 grid grid-cols-2 gap-3">
                    <a
                      href="https://api.whatsapp.com/send?phone=+917703934446&text=Hello%20Team,%20Please%20call%20back.%20Looking%20for%20treatment%20in%20India."
                      className="flex items-center justify-center gap-1.5 bg-green-600 hover:bg-green-700 text-white py-2 px-3 rounded-lg text-sm font-semibold transition-all"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaWhatsapp style={{ fontSize: 18 }} />
                      WhatsApp
                    </a>
                    <button
                      className="flex items-center justify-center gap-1.5 bg-neutral-800 hover:bg-neutral-900 text-white py-2 px-3 rounded-lg text-sm font-semibold transition-all"
                      onClick={() => setFortisContactModalOpen(true)}
                    >
                      <MessageCircle size={16} />
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>

              {/* Doctor 2 */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-2 border border-neutral-100">
                <div className="relative flex justify-center border-b">
                  <img
                    src={drAshokSeth}
                    alt="Dr. Ashok Seth"
                    className="h-60 object-contain"
                  />
                </div>

                <div className="p-6">
                  <div className="flex items-center mb-2">
                    <div className="h-3 w-3 rounded-full bg-green-500 mr-2"></div>
                    <span className="text-sm font-medium text-green-600">Available for Consultation</span>
                  </div>

                  <h3 className="text-xl font-bold text-neutral-900 mb-1">Dr. Ashok Seth</h3>

                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center">
                      <Heart size={16} className="text-blue-600 mr-1.5" />
                      <span className="text-blue-700 text-sm font-medium">Interventional Cardiologist</span>
                    </div>
                    <div className="flex items-center text-amber-400">
                      <Star size={16} className="mr-1 fill-amber-400" />
                      <span className="text-sm font-medium">5.0</span>
                    </div>
                  </div>

                  <div className="mb-4 text-neutral-500 text-sm">
                    <p>30+ years experience</p>
                    <p className="mt-1">Pioneer in advanced cardiovascular procedures and heart surgeries</p>
                  </div>

                  <div className="pt-4 border-t border-neutral-100 grid grid-cols-2 gap-3">
                    <a
                      href="https://api.whatsapp.com/send?phone=+917703934446&text=Hello%20Team,%20Please%20call%20back.%20Looking%20for%20treatment%20in%20India."
                      className="flex items-center justify-center gap-1.5 bg-green-600 hover:bg-green-700 text-white py-2 px-3 rounded-lg text-sm font-semibold transition-all"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaWhatsapp style={{ fontSize: 18 }} />
                      WhatsApp
                    </a>
                    <button
                      className="flex items-center justify-center gap-1.5 bg-neutral-800 hover:bg-neutral-900 text-white py-2 px-3 rounded-lg text-sm font-semibold transition-all"
                      onClick={() => setFortisContactModalOpen(true)}
                    >
                      <MessageCircle size={16} />
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>

              {/* Doctor 3 */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-2 border border-neutral-100">
                <div className="relative flex justify-center border-b">
                  <img
                    src={drSandeepVaishya}
                    alt="Dr. Sandeep Vaishya"
                    className="h-60 object-contain"
                  />
                </div>

                <div className="p-6">
                  <div className="flex items-center mb-2">
                    <div className="h-3 w-3 rounded-full bg-green-500 mr-2"></div>
                    <span className="text-sm font-medium text-green-600">Available for Consultation</span>
                  </div>

                  <h3 className="text-xl font-bold text-neutral-900 mb-1">Dr. Sandeep Vaishya</h3>

                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center">
                      <Brain size={16} className="text-blue-600 mr-1.5" />
                      <span className="text-blue-700 text-sm font-medium">Neurosurgeon</span>
                    </div>
                    <div className="flex items-center text-amber-400">
                      <Star size={16} className="mr-1 fill-amber-400" />
                      <span className="text-sm font-medium">4.8</span>
                    </div>
                  </div>

                  <div className="mb-4 text-neutral-500 text-sm">
                    <p>20+ years experience</p>
                    <p className="mt-1">Expert in advanced neurosurgical procedures and brain treatments</p>
                  </div>

                  <div className="pt-4 border-t border-neutral-100 grid grid-cols-2 gap-3">
                    <a
                      href="https://api.whatsapp.com/send?phone=+917703934446&text=Hello%20Team,%20Please%20call%20back.%20Looking%20for%20treatment%20in%20India."
                      className="flex items-center justify-center gap-1.5 bg-green-600 hover:bg-green-700 text-white py-2 px-3 rounded-lg text-sm font-semibold transition-all"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaWhatsapp style={{ fontSize: 18 }} />
                      WhatsApp
                    </a>
                    <button
                      className="flex items-center justify-center gap-1.5 bg-neutral-800 hover:bg-neutral-900 text-white py-2 px-3 rounded-lg text-sm font-semibold transition-all"
                      onClick={() => setFortisContactModalOpen(true)}
                    >
                      <MessageCircle size={16} />
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 flex justify-center">
            <a
              href="/hospitals/fortis/doctors"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-all shadow-md hover:shadow-lg hover:-translate-y-1"
            >
              See More Doctors
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
            </a>
          </div>
        </section>
        <section className="py-16 bg-neutral-50">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-neutral-900 mb-4">
                Treatments We Offer <span className="text-green-600">- Across All Specialties</span>
              </h2>
              <p className="text-neutral-600 max-w-3xl mx-auto">
                Our world-class medical team provides comprehensive care across all major specialties,
                using cutting-edge technology and advanced treatment protocols.
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
              {specialities.map((speciality, index) => (
                <div
                  key={index}
                  onClick={() => handleSpecialityClick(speciality.name)}
                  className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 p-4 flex flex-col items-center justify-center hover:-translate-y-1 border border-neutral-100 cursor-pointer"
                >
                  <div className="w-14 h-14 flex items-center justify-center rounded-full mb-3 bg-green-50 text-green-600">
                    {speciality.lucideIcon}
                  </div>
                  <h3 className="text-neutral-800 font-medium text-center text-sm">{speciality.name}</h3>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <a
                href="https://api.whatsapp.com/send?phone=+917703934446&text=Hello%20Team,%20Please%20call%20back.%20Looking%20for%20treatment%20in%20India."
                className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-medium transition-all shadow hover:shadow-lg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp style={{ fontSize: 20 }} />
                WhatsApp
              </a>
              <button
                className="flex items-center justify-center gap-2 bg-neutral-800 hover:bg-neutral-900 text-white px-6 py-3 rounded-lg font-medium transition-all shadow hover:shadow-lg"
                onClick={() => setFortisContactModalOpen(true)}
              >
                <MessageCircle size={18} />
                Contact Us
              </button>
            </div>
          </div>
        </section>

        <section className="hospital5stats5banner">
          <div className="hospital5container">
            <div className="hospital5stats5grid">
              {stats.map((stat, index) => (
                <div key={index} className="hospital5stat5box">
                  <div
                    ref={(el) => (countersRef.current[index] = el)}
                    className="hospital5stat5value"
                  >
                    {stats[index].value}
                  </div>
                  <div className="hospital5stat5label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="why-choose-us">
          <div className="container mx-auto">
            <div className="top5header">
              <h2>
                Why Choose Us? -{" "}
                <span>Committed to Excellence in Healthcare</span>
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
              {reasons.map((reason, index) => (
                <div
                  key={index}
                  className="reason-card"
                  onClick={() => setModalOpen(true)} // Open the modal on click
                  style={{ cursor: "pointer" }} // Add pointer cursor for better UX
                >
                  <div className="reason-content">
                    <div className="reason-icon">{reason.icon}</div>
                    <h3 className="reason-title">{reason.title}</h3>
                    <p className="reason-description">{reason.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Add the FortisContactModal */}
          <FortisContactModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
          />
          <div className="speciality5buttons">
            <a
              href="https://api.whatsapp.com/send?phone=+917703934446&text=Hello%20Team,%20Please%20call%20back.%20Looking%20for%20treatment%20in%20India."
              className="flex items-center justify-center gap-1.5 bg-green-600 hover:bg-green-700 text-white py-2 px-3 rounded-lg text-sm font-semibold transition-all"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp style={{ fontSize: 18 }} />
              WhatsApp
            </a>
            <button
              className="flex items-center justify-center gap-1.5 bg-neutral-800 hover:bg-neutral-900 text-white py-2 px-3 rounded-lg text-sm font-semibold transition-all"
              onClick={() => setFortisContactModalOpen(true)}
            >
              <MessageCircle size={16} />
              Contact Us
            </button>
          </div>
        </section>



        <section
          className="about5section2"
          style={{
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            padding: "3rem 1rem",
          }}
        >
          <div className="about5container">
            <h2 className="about5heading">
              About <span>Fortis Hospital, India</span>
            </h2>

            <div className="about5grid">
              <div className="about5left">
                <img
                  src={forties}
                  alt="Fortis Hospital"
                  className="about5image"
                />

                <p className="about5text2">
                  Fortis Memorial Research Institute is acclaimed as one of
                  India's most advanced healthcare facilities, offering
                  cutting-edge medical technology and expert clinical care.
                  Located in Gurgaon, it serves as a beacon of excellence in
                  healthcare, attracting patients from across India and
                  internationally.
                </p>

                <p className="about5text2">
                  Our vision is to create a world-class integrated healthcare
                  system, entailing the finest medical skills combined with
                  compassionate patient care. With experienced doctors and
                  state-of-the-art facilities, we provide comprehensive
                  healthcare services across multiple specialties.
                </p>

                <button
                  className="learn5more5button"
                  onClick={() => setModalOpen(true)} // Open the modal on button click
                >
                  Learn More
                </button>
              </div>

              <div className="about5right">
                <div className="highlight5card">
                  <h3 className="highlight5title">Key Highlights</h3>
                  <ul className="highlight5list">
                    {highlights.map((item, i) => (
                      <li key={i} className="highlight5item">
                        <span className="check5icon">✓</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="stats5grid2">
                    {stats.map((stat, index) => (
                      <div key={index} className="stat5box">
                        <div
                          ref={(el) => (countersRef2.current[index] = el)}
                          className="stat5value"
                        >
                          {stat.value}
                        </div>
                        <div className="stat5label">{stat.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Add the FortisContactModal */}
          <FortisContactModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
          />
        </section>

        {/* Video Testimonials Section */}
        <section className="py-16 bg-neutral-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-neutral-900 mb-4">
                Patient Video Testimonials <span className="text-green-600">- Real Stories of Recovery</span>
              </h2>
              <p className="text-neutral-600 max-w-3xl mx-auto">
                Hear directly from our international patients about their treatment journey and experience at Fortis Hospital.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {/* Video 1 */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <div className="relative pt-[56.25%]"> {/* 16:9 Aspect Ratio */}
                  <iframe 
                    className="absolute top-0 left-0 w-full h-full"
                    src="https://www.youtube.com/embed/9E1O_5oAl4E?si=X4VYybtErQNn6sQe" 
                    title="YouTube video player" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerPolicy="strict-origin-when-cross-origin" 
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="p-4">
                  <h3 className="font-medium text-lg text-neutral-800 mb-1">Ms. Regina - Zambia</h3>
                  <p className="text-neutral-600 text-sm">Ms. Regina from Zambia recovered from gynaecological issues at Fortis La Femme, New Delhi.</p>
                </div>
              </div>

              {/* Video 2 */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <div className="relative pt-[56.25%]"> {/* 16:9 Aspect Ratio */}
                  <iframe 
                    className="absolute top-0 left-0 w-full h-full"
                    src="https://www.youtube.com/embed/Hb342u-nD-Y?si=ZOJCN8FIp0GuDSvE" 
                    title="YouTube video player" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerPolicy="strict-origin-when-cross-origin" 
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="p-4">
                  <h3 className="font-medium text-lg text-neutral-800 mb-1">Sinead Tara Kelly - UK
                  </h3>
                  <p className="text-neutral-600 text-sm">Sinead from the UK recovered after gender affirmation surgery at Fortis Shalimar Bagh.</p>
                </div>
              </div>

              {/* Video 3 */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <div className="relative pt-[56.25%]"> {/* 16:9 Aspect Ratio */}
                  <iframe 
                    className="absolute top-0 left-0 w-full h-full"
                    src="https://www.youtube.com/embed/hObD4nYAbfE?si=ECpdNX8j6l3h52Lp" 
                    title="YouTube video player" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerPolicy="strict-origin-when-cross-origin" 
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="p-4">
                  <h3 className="font-medium text-lg text-neutral-800 mb-1">Mr. Richard Poole - UK
                  </h3>
                  <p className="text-neutral-600 text-sm">Mr. Poole from the UK underwent Total Arterial Bypass Surgery at Fortis Hospital, Noida, to treat coronary artery disease.</p>
                </div>
              </div>

              {/* Video 4 */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <div className="relative pt-[56.25%]"> {/* 16:9 Aspect Ratio */}
                  <iframe 
                    className="absolute top-0 left-0 w-full h-full"
                    src="https://www.youtube.com/embed/V--iVIDecvU?si=iPjaQbMw-LzsdVd4" 
                    title="YouTube video player" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerPolicy="strict-origin-when-cross-origin" 
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="p-4">
                  <h3 className="font-medium text-lg text-neutral-800 mb-1">Children from Tanzania
                  </h3>
                  <p className="text-neutral-600 text-sm">Fortis Healthcare successfully performed cardiac procedures on children from Tanzania, providing life-saving treatment.</p>
                </div>
              </div>

              {/* Video 5 */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <div className="relative pt-[56.25%]"> {/* 16:9 Aspect Ratio */}
                  <iframe 
                    className="absolute top-0 left-0 w-full h-full"
                   src="https://www.youtube.com/embed/iwjup5XmnKM?si=q0A6J3s-sbpmq8JV"
                    title="YouTube video player" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerPolicy="strict-origin-when-cross-origin" 
                    allowFullScreen
                  ></iframe>
                  
                </div>
                <div className="p-4">
                  <h3 className="font-medium text-lg text-neutral-800 mb-1">Chul Both Chan - Cambodia                  </h3>
                  <p className="text-neutral-600 text-sm">Chul Both Chan from Cambodia, suffering from Chronic Kidney Disease, fully recovered with the help of the expert team at Fortis Vasant Kunj.</p>
                </div>
              </div>

              {/* Video 6 */}
              <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <div className="relative pt-[56.25%]"> {/* 16:9 Aspect Ratio */}
                  <iframe 
                    className="absolute top-0 left-0 w-full h-full"
                    src="https://www.youtube.com/embed/9j4kdYEmuZw?si=BK2EWNMW09jSZ9gV" 
                    title="YouTube video player" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerPolicy="strict-origin-when-cross-origin" 
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="p-4">
                  <h3 className="font-medium text-lg text-neutral-800 mb-1">Mayo - Nigeria
                  </h3>
                  <p className="text-neutral-600 text-sm">Mayo from Nigeria underwent a successful bone marrow transplant at Fortis Gurugram and is now playing football.</p>
                </div>
              </div>
            </div>

            <div className="mt-10 flex justify-center">
              <button 
                onClick={() => setFortisContactModalOpen(true)}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-all shadow-md hover:shadow-lg hover:-translate-y-1"
              >
                Get Consultation
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
              </button>
            </div>
          </div>
        </section>

        <section className="contact5section bg-gradient-to-br from-white to-green-50 py-16">
          <div className="max-w-5xl mx-auto sm:px-6 lg:px-8">
            <div className="text-center mb-10">
              <span className="inline-block px-4 py-1 bg-green-100 text-green-800 text-sm font-medium rounded-full mb-3">Schedule Your Visit</span>
              <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-4">Request an Appointment with <span className="text-green-600">Expert Doctors</span></h2>
              <p className="text-neutral-600 max-w-2xl mx-auto">Get personalized healthcare from world-renowned specialists. Our international patient team will coordinate your entire treatment journey.</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg overflow-hidden animate-[fadeIn_0.3s_ease-out] relative z-10">
              <div className="grid grid-cols-1 md:grid-cols-5">
                <div className="md:col-span-2 bg-green-600 p-6 md:p-8 flex flex-col justify-center relative overflow-hidden">
                  <div className="absolute inset-0 opacity-10">
                    <svg width="100%" height="100%" className="absolute inset-0">
                      <pattern id="appointmentPattern" width="40" height="40" patternUnits="userSpaceOnUse">
                        <path d="M0 20h40M20 0v40" stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.8" className="text-white" />
                      </pattern>
                      <rect width="100%" height="100%" fill="url(#appointmentPattern)" />
                    </svg>
                  </div>
                  
                  <h3 className="text-white text-2xl font-bold mb-4 relative z-10">Why Request an Appointment?</h3>
                  
                  <ul className="space-y-5 text-white relative z-10">
                    <li className="flex items-start">
                      <div className="flex-shrink-0 h-9 w-9 rounded-full bg-green-700 flex items-center justify-center mr-3 shadow-sm">
                        <FaCalendarCheck className="h-4.5 w-4.5 text-white" size={18} />
                      </div>
                      <div className="mt-0.5">
                        <span className="font-medium">Priority scheduling</span>
                        <p className="text-white text-opacity-80 text-sm mt-0.5">Get appointments with specialist doctors on priority</p>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <div className="flex-shrink-0 h-9 w-9 rounded-full bg-green-700 flex items-center justify-center mr-3 shadow-sm">
                        <FaUserMd className="h-4.5 w-4.5 text-white" size={18} />
                      </div>
                      <div className="mt-0.5">
                        <span className="font-medium">Personalized treatment plan</span>
                        <p className="text-white text-opacity-80 text-sm mt-0.5">Customized care based on your specific medical needs</p>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <div className="flex-shrink-0 h-9 w-9 rounded-full bg-green-700 flex items-center justify-center mr-3 shadow-sm">
                        <FaPlane className="h-4.5 w-4.5 text-white" size={18} />
                      </div>
                      <div className="mt-0.5">
                        <span className="font-medium">Travel assistance</span>
                        <p className="text-white text-opacity-80 text-sm mt-0.5">Complete help with travel and accommodation arrangements</p>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <div className="flex-shrink-0 h-9 w-9 rounded-full bg-green-700 flex items-center justify-center mr-3 shadow-sm">
                        <FaPassport className="h-4.5 w-4.5 text-white" size={18} />
                      </div>
                      <div className="mt-0.5">
                        <span className="font-medium">Visa support</span>
                        <p className="text-white text-opacity-80 text-sm mt-0.5">Medical visa assistance and documentation help</p>
                      </div>
                    </li>
                  </ul>
                </div>
                
                <div className="md:col-span-3 p-3 md:p-8">
                  <p className="text-center text-neutral-500 text-sm mt-0 mb-4">
                    Fill out the form below to schedule an appointment with our specialists.
                  </p>

                  <form onSubmit={handleSubmit} className="flex flex-col gap-3" noValidate>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-5">
                      <div className="flex flex-col">
                        <label htmlFor="appointment-name" className="mb-1 text-sm font-medium text-neutral-600">Name*</label>
                        <input
                          id="appointment-name"
                          type="text"
                          name="name"
                          className={`px-3 py-2 border ${nameError ? 'border-red-500 bg-red-50' : 'border-neutral-200'} rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 focus:border-green-500 transition`}
                          value={name}
                          onChange={handleNameChange}
                          placeholder="Your full name"
                          required
                        />
                        {nameError && (
                          <div className="flex items-center gap-1 text-red-600 text-xs mt-1">
                            <AlertCircle size={12} />
                            <span>{nameError}</span>
                          </div>
                        )}
                      </div>

                      <div className="flex flex-col">
                        <label htmlFor="appointment-email" className="mb-1 text-sm font-medium text-neutral-600">Email*</label>
                        <input
                          id="appointment-email"
                          type="email"
                          name="email"
                          className={`px-3 py-2 border ${emailError ? 'border-red-500 bg-red-50' : 'border-neutral-200'} rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 focus:border-green-500 transition`}
                          value={email}
                          onChange={handleEmailChange}
                          placeholder="Your email address"
                          required
                        />
                        {emailError && (
                          <div className="flex items-center gap-1 text-red-600 text-xs mt-1">
                            <AlertCircle size={12} />
                            <span>{emailError}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="appointment-phone" className="mb-1 text-sm font-medium text-neutral-600">Phone*</label>
                      <input
                        id="appointment-phone"
                        type="tel"
                        name="phone"
                        className={`px-3 py-2 border ${phoneError ? 'border-red-500 bg-red-50' : 'border-neutral-200'} rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 focus:border-green-500 transition`}
                        value={phone}
                        onChange={handlePhoneChange}
                        placeholder="+91 xxxxx xxxxx (with country code)"
                        required
                      />
                      {phoneError && (
                        <div className="flex items-center gap-1 text-red-600 text-xs mt-1">
                          <AlertCircle size={12} />
                          <span>{phoneError}</span>
                        </div>
                      )}
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="appointment-country" className="mb-1 text-sm font-medium text-neutral-600">Country*</label>
                      <select
                        id="appointment-country"
                        name="country"
                        className={`px-3 py-2 border ${!country && 'border-red-500 bg-red-50'} border-neutral-200 rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 focus:border-green-500 transition`}
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                        required
                      >
                        <option value="">Select your country</option>
                        {countriesList.map((item, index) => (
                          <option value={item.name} key={`appointment-${item.name}-${index}`}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="appointment-message" className="mb-1 text-sm font-medium text-neutral-600">Your Medical Query*</label>
                      <textarea
                        id="appointment-message"
                        name="message"
                        className={`px-3 py-2 border ${messageError ? 'border-red-500 bg-red-50' : 'border-neutral-200'} rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 focus:border-green-500 transition resize-y min-h-[120px]`}
                        value={message}
                        onChange={handleMessageChange}
                        rows="4"
                        placeholder="Please briefly describe your medical condition and treatment needs"
                        required
                      ></textarea>
                      {messageError && (
                        <div className="flex items-center gap-1 text-red-600 text-xs mt-1">
                          <AlertCircle size={12} />
                          <span>{messageError}</span>
                        </div>
                      )}
                    </div>

                    <div className="flex justify-center mt-4">
                      <button
                        type="submit"
                        className="flex items-center justify-center gap-2 bg-green-600 text-white py-3 px-6 border-none rounded-md text-base font-semibold cursor-pointer transition duration-200 ease-in-out hover:bg-green-700 hover:-translate-y-1 active:translate-y-0 disabled:cursor-not-allowed disabled:hover:translate-y-0 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 w-full md:w-auto md:min-w-[200px]"
                        disabled={loading}
                      >
                        {loading ? (
                          <Loader2 className="animate-spin" />
                        ) : (
                          <>
                            <Calendar size={18} />
                            <span>Schedule Appointment</span>
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </section>

        <section className="bg-gradient-to-r from-green-50 to-green-100 py-12 md:py-16 overflow-hidden relative">
          {/* Background pattern */}
          <div className="absolute inset-0 z-0 opacity-10">
            <svg width="100%" height="100%" className="absolute inset-0">
              <pattern id="healthGrid" width="40" height="40" patternUnits="userSpaceOnUse">
                <path d="M0 20h40M20 0v40" stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.8" className="text-green-800" />
              </pattern>
              <rect width="100%" height="100%" fill="url(#healthGrid)" />
            </svg>
          </div>

          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-12 mb-10 md:mb-16">
              <div className="flex items-center">
                <img src={rx__logo} alt="RxOne Logo" className="h-16 md:h-20 object-contain animate-[fadeIn_0.5s_ease-out]" />
              </div>

              <div className="flex-1 text-center md:text-left">
                <h2 className="text-3xl md:text-4xl font-bold text-left tracking-tight text-neutral-900 animate-[fadeIn_0.6s_ease-out]">
                  Trusted Platform for <span className="text-green-600">Global Health Travel</span>
                </h2>
                <p className="mt-3 text-lg md:text-xl font-medium text-neutral-700 text-left animate-[fadeIn_0.7s_ease-out]">
                  Connecting patients to world-class healthcare across borders with seamless care coordination
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              <div className="bg-white rounded-xl shadow-md p-6 transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1 animate-[fadeIn_0.8s_ease-out]">
                <div className="flex items-center gap-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                    <GroupIcon className="w-6 h-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="text-2xl md:text-3xl font-bold text-green-600">46,211+</h3>
                    <p className="text-neutral-700 font-medium">Patients Served Globally</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-md p-6 transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1 animate-[fadeIn_0.9s_ease-out]">
                <div className="flex items-center gap-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                    <PublicIcon className="w-6 h-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="text-2xl md:text-3xl font-bold text-green-600">38+</h3>
                    <p className="text-neutral-700 font-medium">Countries Reached</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-md p-6 transform transition-all duration-300 hover:shadow-lg hover:-translate-y-1 animate-[fadeIn_1s_ease-out]">
                <div className="flex items-center gap-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                    <LocalHospitalIcon className="w-6 h-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="text-2xl md:text-3xl font-bold text-green-600">345+</h3>
                    <p className="text-neutral-700 font-medium">Hospital Partners</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-12 flex justify-center">
              <button onClick={() => setFortisContactModalOpen(true)} className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-300 transform hover:-translate-y-1">
                Schedule Your Consultation
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>

          <style jsx>{`
            @keyframes fadeIn {
              from { opacity: 0; transform: scale(0.95) translateY(10px); }
              to { opacity: 1; transform: scale(1) translateY(0); }
            }
            @keyframes messageAppear {
              from { opacity: 0; transform: translateX(-50%) translateY(-10px); }
              to { opacity: 1; transform: translateX(-50%) translateY(0); }
            }
          `}</style>
        </section>
        <section className="accreditation5section">
          <div className="container mx-auto py-12 px-4 sm:px-6 lg:px-8">
            <div className="top5header text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-bold">
                Accredited by - <span className="text-green-600">Recognized for Excellence</span>
              </h2>
              <p className="mt-4 text-lg text-neutral-600 max-w-3xl text-left">
                Our hospital is accredited by leading international healthcare organizations, ensuring we maintain the highest standards of patient care and safety.
              </p>
            </div>

            <div className="accreditation5grid">
              {accreditations.map((item, index) => (
                <div key={index} className="accreditation5item transition-all duration-300 hover:transform hover:scale-110">
                  <img
                    src={item.imgSrc}
                    alt={item.name}
                    className="accreditation5img"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
<div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg px-3 py-2 flex justify-center gap-3 block sm:hidden">
  {/* WhatsApp Button */}
  <a
    href="https://api.whatsapp.com/send?phone=+917703934446&text=Hello%20Team,%20Please%20call%20back.%20Looking%20for%20treatment%20in%20India."
    className="flex-1 flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg text-base font-semibold shadow transition-all"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaWhatsapp className="text-lg" />
    <span>WhatsApp</span>
  </a>

  {/* Call Button */}
  <a
    href="tel:+911140847007"
    className="flex-1 flex items-center justify-center gap-2 border-2 border-green-600 text-green-600 hover:bg-green-50 hover:border-green-700 py-2 rounded-lg text-base font-semibold transition-all"
  >
    <Phone size={18} />
    <span>Call</span>
  </a>
</div>

        <footer className="bg-neutral-900 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {/* Column 1: About */}
              <div>
                <h3 className="text-xl font-semibold mb-4 text-green-400">About RxOne</h3>
                <p className="text-gray-400 mb-4">
              Building Simple, Easy to Use and Effective Digital Health solutions for users, to solve care accessibility challenge in India and Worldwide.</p>

                <div className="flex space-x-4 mt-4">
                  <a
                    href="https://www.facebook.com/profile.php?id=100089472039715"
                    className="w-8 h-8 rounded-full bg-neutral-800 flex items-center justify-center transition-all hover:bg-green-600"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebookF className="text-white text-sm" />
                  </a>
                  <a
                    href="https://twitter.com/RxOneCare"
                    className="w-8 h-8 rounded-full bg-neutral-800 flex items-center justify-center transition-all hover:bg-green-600"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaTwitter className="text-white text-sm" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/rx-one"
                    className="w-8 h-8 rounded-full bg-neutral-800 flex items-center justify-center transition-all hover:bg-green-600"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedinIn className="text-white text-sm" />
                  </a>
                  <a
                    href="https://www.instagram.com/rxone_care?igsh=bzdsdTBzNjB3aTVr"
                    className="w-8 h-8 rounded-full bg-neutral-800 flex items-center justify-center transition-all hover:bg-green-600"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram className="text-white text-sm" />
                  </a>
                </div>
              </div>

              {/* Column 2: Quick Links */}
              <div>
                <h3 className="text-xl font-semibold mb-4 text-green-400">Quick Links</h3>
                <ul className="space-y-2">
                  {['Hospitals', 'Doctors', 'Treatments', 'Blogs', 'About Us', 'Contact Us'].map((link, index) => (
                    <li key={index}>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setFortisContactModalOpen(true);
                        }}
                        className="text-neutral-400 hover:text-green-400 transition-colors flex items-center"
                      >
                        <span className="mr-2">›</span> {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Column 3: Contact */}
              <div>
                <h3 className="text-xl font-semibold mb-4 text-green-400">Get in Touch</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <Phone className="h-5 w-5 text-green-400 mr-3 mt-0.5" />
                    <span className="text-neutral-400">+91 770 393 4446</span>
                  </li>
                  <li className="flex items-start">
                    <FaWhatsapp className="h-5 w-5 text-green-400 mr-3 mt-0.5" />
                    <a
                      href="https://api.whatsapp.com/send?phone=+917703934446&text=Hello%20Team,%20Please%20call%20back.%20Looking%20for%20treatment%20in%20India."
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-neutral-400 hover:text-green-400"
                    >
                      WhatsApp Support
                    </a>
                  </li>
                  <li className="flex items-start">
                    <FaTelegram className="h-5 w-5 text-green-400 mr-3 mt-0.5" />
                    <a
                      href="https://t.me/RxOneSupport"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-neutral-400 hover:text-green-400"
                    >
                      Telegram Support
                    </a>
                  </li>
                  <li className="flex items-start">
                    <MessageCircle className="h-5 w-5 text-green-400 mr-3 mt-0.5" />
                    <button
                      onClick={() => setFortisContactModalOpen(true)}
                      className="text-neutral-400 hover:text-green-400 text-left"
                    >
                      Send a Message
                    </button>
                  </li>
                </ul>
              </div>

              {/* Column 4: Mobile Apps */}
              <div>
                <h3 className="text-xl font-semibold mb-4 text-green-400">Mobile Apps</h3>
                <p className="text-neutral-400 mb-4">Download the RxOne mobile app for seamless healthcare coordination on the go.</p>
                <div className="space-y-3">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.rxone"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center px-4 py-2 bg-neutral-800 rounded-lg hover:bg-neutral-700 transition-all"
                  >
                    <FaGooglePlay className="h-5 w-5 text-white mr-3" />
                    <div>
                      <div className="text-xs text-neutral-400">GET IT ON</div>
                      <div className="text-sm font-medium">Google Play</div>
                    </div>
                  </a>
                  <a
                    href="https://apps.apple.com/in/app/rxone-care-companion/id6479252685"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center px-4 py-2 bg-neutral-800 rounded-lg hover:bg-neutral-700 transition-all"
                  >
                    <FaApple className="h-5 w-5 text-white mr-3" />
                    <div>
                      <div className="text-xs text-neutral-400">Download on the</div>
                      <div className="text-sm font-medium">App Store</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-neutral-800 flex flex-col md:flex-row justify-center items-center">
              <p className="text-neutral-500 text-sm mb-4 md:mb-0">© {new Date().getFullYear()} Rx One Care Pvt. Ltd. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default FortisHealthcare;

